import { render, staticRenderFns } from "./ConsultarealizadaGrid.vue?vue&type=template&id=279d4c11&scoped=true&"
import script from "./ConsultarealizadaGrid.vue?vue&type=script&lang=js&"
export * from "./ConsultarealizadaGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279d4c11",
  null
  
)

/* custom blocks */
import block0 from "./ConsultarealizadaGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports